/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select/creatable";

import { ModalContext } from "../../context/modal";
import { DefaultButton, MyModalBody } from "../../style/default";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { customStyles } from "../../style/selectStyles";

function LinkBot({ open, populateTable, data, bots }) {
	const { handleOpenModal } = useContext(ModalContext);

	const botSelected = bots.find((b) => b._id == data.elozBotId);
	const defaultBot = {
		value: botSelected?._id,
		label: botSelected?.name,
	};

	const [account, setAccount] = useState(defaultBot);

	async function handleLinkBot() {
		try {
			await authApi.post(`/temp/set-eloz-bot`, {
				number: data.number,
				botId: account.value,
			});
			toast.success("Bot associado com sucesso", TOASTIFY_OPTIONS);
			populateTable({});
			handleOpenModal();
		} catch (error) {
			toast.error("Erro ao editar bot", TOASTIFY_OPTIONS);
		}
	}

	return (
		<Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Associar Bot</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<div>
						<label htmlFor="">Bot</label>
						<Select
							styles={customStyles}
							placeholder="Ex: Bot-cliente"
							noOptionsMessage={() => "Nenhum resultado encontrado"}
							options={bots.map((d) => ({
								value: d._id,
								label: d.name,
							}))}
							value={account}
							onChange={setAccount}
						/>
					</div>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton onClick={handleLinkBot}>Associar</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
}

export { LinkBot };
